import PropTypes from 'prop-types';
import React, { Suspense } from 'react';
import { CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useIntl } from 'react-intl';

SuspenseContainer.propTypes = {
  children: PropTypes.node
};

export default function SuspenseContainer({ children }) {
  const { formatMessage: msg } = useIntl();

  return (
    <Suspense
      fallback={
        <Grid container direction="column" alignItems="center" justifyContent="center">
          <CircularProgress aria-label={msg({ id: 'common.progress' })} />
        </Grid>
      }
    >
      {children}
    </Suspense>
  );
}
